
import React from 'react'
import { TextField, RaisedButton } from 'material-ui';
import _ from 'lodash'
class OrderNotes extends React.Component {
  constructor(props) {
    super(props)
  }
  renderOrderNotes(order) {
    const orderNotes = order.notes.order;
    const orderNotesDisplay = [];
    if (!_.isEmpty(orderNotes)) {
      _.map(orderNotes, (note, i) => {
        orderNotesDisplay.push(
          <tr className="row" key={i}>
            <td className="col" >{note.admin}</td>
            <td className="col" >{new Date(note.date).toLocaleString()}</td>
            <td className="col" style={{ wordWrap: 'break-word' }}>{note.text}</td>
          </tr>);
      });
    }
    const textBox = (
      <TextField
        value={this.props.noteText}
        name="noteText"
        multiLine
        underlineShow={false}
        onChange={this.props.handleNoteChange}
        rows={10}
        rowsMax={10}
        style={{ width: '80vw' }}
        textareaStyle={{ border: '1px solid black' }}
      />);
    const saveButton = (<RaisedButton
      label="Save"
      primary
      onClick={this.props.handleSaveNote}
    />);
    const hideView = this.props.disableView ? 'none' : 'inline'
    return (
      <div>
        <br />
        <details style={{display: hideView}}>
          <summary>Add Note</summary>
          {textBox}
          <br />
          {saveButton}
        </details>
        <h3 style={{ margin: '20px 0' }}>Previous Notes</h3>
        <table className="table table-striped">
          <thead>
            <tr className="row">
              <th className="col" scope="col">Representative</th>
              <th className="col" scope="col">Date</th>
              <th className="col" scope="col">Details</th>
            </tr>
          </thead>
          <tbody>
            {orderNotesDisplay}
          </tbody>
        </table>
      </div>);
  }
  render() {
    const { order } = this.props
    return (
      <div>
        <h2>Order Notes</h2>
        <div style={{ paddingLeft: '40px', paddingRight: '20px', paddingBottom: '20px' }}>
          {this.renderOrderNotes(order)}
        </div>
      </div>
    )
  }
}
export default OrderNotes;


// WEBPACK FOOTER //
// ./src/components/orders/Common/OrderNotes.js